var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "&ns_svg;",
    xmlnsXlink: "&ns_xlink;",
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    overflow: "visible",
    enableBackground: "new 0 0 144 144",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Future"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Future_1_",
    fill: "#f7e000",
    d: "M70.866,2.268C31.728,2.268,0,33.996,0,73.134C0,112.272,31.728,144,70.866,144 c39.139,0,70.866-31.728,70.866-70.866C141.732,33.996,110.005,2.268,70.866,2.268z M101.498,98.231 c-6.752,0-12.876-2.664-17.395-6.994L51.779,59.12c-3.408-3.218-7.877-5.072-12.936-5.072c-10.513,0-19.035,8.522-19.035,19.035 c0,10.513,8.522,19.035,19.035,19.035c3.971,0,7.827-1.233,11.093-3.312L61.034,77.71l4.443,4.443L54.28,93.346 c-4.469,3.137-9.795,4.885-15.437,4.885c-13.89,0-25.148-11.259-25.148-25.147c0-13.891,11.259-25.148,25.148-25.148 c6.752,0,12.876,2.665,17.394,6.994L88.634,87.11c3.408,3.219,7.806,5.008,12.864,5.008c10.513,0,19.035-8.522,19.035-19.035 c0-10.513-8.522-19.035-19.035-19.035c-4.557,0-8.729,1.611-12,4.285l5.392,5.392l-17.928,2.583l2.583-17.928l5.611,5.612 c4.395-3.771,10.098-6.057,16.342-6.057c13.89,0,25.148,11.259,25.148,25.148C126.646,86.974,115.388,98.231,101.498,98.231z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuture);
export default __webpack_public_path__ + "static/media/future.1a923ea0.svg";
export { ForwardRef as ReactComponent };